export const error = state => state.error
export const isLoading = state => state.isLoading
export const items = state => state.items
export const view = state => state.view
export const tableItems = state => {
  let returnItems = []
  state.items.forEach(function (item) {
    let returnItem = {
      data: item,
      columns: [
        {
          field: 'name',
          value: item.name,
          type: 'string'
        },
        {
          field: 'description',
          value: item.description,
          type: 'text',
          textDisplay: 'nowrap'
        }
      ]
    }
    returnItems.push(returnItem)
  })
  return returnItems
}
